import { type Repub } from '@cx-modules/constants';

export const repubs: ReadonlyArray<readonly [Repub, string]> = [
  ['OC', '/'],
  ['US', 'us/'],
  ['DE', 'de/'],
  ['CO', 'co/'],
  ['AU', 'au/'],
  ['NZ', 'nz/'],
  ['IN', 'in/'],
  ['PT', 'pt/'],
  ['ZA', 'za/'],
  ['KE', 'ke/'],
  ['NG', 'ng/'],
  ['NL', 'nl/'],
  ['FR', 'fr/'],
  ['SE', 'se/'],
  ['SM', 'sm/'],
  ['CX', 'cx/'],
  ['CA', 'ca/'],
  ['ES', 'es/'],
  ['IT', 'it/'],
  ['BR', 'br/'],
  ['GZ', '/'],
  ['WS', '/'],
];

function formatRepubPath(repub: Repub, useRootSlash: boolean): string {
  const repubEntry = repubs.find(([code]) => code === repub);
  if (!repubEntry) return useRootSlash ? '/' : '';

  const path = repubEntry[1];
  if (path === '/') return useRootSlash ? '/' : '';

  return `/${path.replace(/\/$/, '')}`;
}

export function getRepubPath(repub: Repub): string {
  return formatRepubPath(repub, false);
}

export function getRepubHomeUrl(repub: Repub): string {
  return formatRepubPath(repub, true);
}

export function removeRepubPrefix(path: string, repub: Repub): string {
  const repubPath = getRepubPath(repub);

  // If repub has no path prefix (e.g., OC, WS), return the path as-is
  if (!repubPath) {
    return path;
  }

  // If path is exactly the prefix or the prefix followed by a segment boundary, remove it.
  // The `+ '/'` check guards against prefix collisions (e.g. '/use-terms' must not match '/us').
  if (path === repubPath || path.startsWith(`${repubPath}/`)) {
    return path.slice(repubPath.length) || '/';
  }

  // Otherwise, return the path as-is
  return path;
}

// Repubs that belong to the "Latam" commercial region. CO/BR are the only repubs whose
// `RepubConfig.countryCode` (modules/constants/src/lib/repubs.ts) is a Latin American country —
// there is no existing "Latam" grouping anywhere else in the codebase to defer to.
export const LATAM_REPUBS: readonly Repub[] = ['CO', 'BR'];

/** UK region — the root/no-prefix Oddschecker repub, distinct from WS (also root-pathed). */
export function isUkRepub(repub: Repub): boolean {
  return repub === 'OC';
}

export function isLatamRepub(repub: Repub): boolean {
  return LATAM_REPUBS.includes(repub);
}
